<template>
  <div class="col-start-2 col-span-12 md:col-start-2 grid grid-cols-4">
    <p v-if="title" :class="headerStyle">{{ title }}</p>
    <rich-text
      v-if="description"
      :text="description"
      :isUmbraco="isUmbraco"
      :theme="themeType"
      classes="mb-14 col-span-4 md:col-span-2 md:col-start-1 md:row-span-2"
    />
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from "vue";
import RichText from "@components/Typography/RichText.ce.vue";
import { ThemeType } from "@/types/types";

export interface PageHeaderProps {
  title?: string;
  description?: string;
  classes?: string;
  themeType: ThemeType;
  isUmbraco: boolean;
  showSlot: boolean;
}

const props = withDefaults(defineProps<PageHeaderProps>(), {
  isUmbraco: false,
  showSlot: false,
});

const { title, description, themeType, isUmbraco } = toRefs(props);

const headerStyle = computed(() => {
  const color =
    isUmbraco.value && themeType.value === "dark"
      ? "text-white"
      : isUmbraco.value && themeType.value === "light"
      ? "text-aubergine"
      : "text-typography";
  return `h1 mb-6 ${color} col-span-4 md:col-span-2 md:row-span-1`;
});
</script>
